(function () {
  const init = async () => {
    console.log('--- Judge.me Init Start ---');
    
    // Find all review containers (support multiple instances although unlikely)
    const reviewSections = document.querySelectorAll('.judgeme-reviews');
    
    reviewSections.forEach(async (section) => {
      const sectionId = section.getAttribute('data-section-id');
      const container = document.getElementById(`judgeme-container-${sectionId}`);
      const v2025Container = document.getElementById(`judgeme-v2025-${sectionId}`);
      
      if (!container || !v2025Container) return;

      // HTML entity unescape helper
      const unescapeHtml = (html) => {
        const doc = new DOMParser().parseFromString(html, "text/html");
        return doc.documentElement.textContent;
      };

      let reviewsData = [];
      try {
        const rawJson = v2025Container.innerHTML.trim(); 
        const cleanJson = unescapeHtml(rawJson);
        const parsed = JSON.parse(cleanJson);
        
        reviewsData = parsed.photo_gallery || parsed.reviews || (Array.isArray(parsed) ? parsed : []);
      } catch (e) {
        console.error('CRITICAL: Erro ao processar JSON Judge.me V2025:', e);
        return;
      }

      if (!reviewsData.length) return;

      // Enrich reviews with images
      const fetchProductImage = async (review) => {
        // Fallback: às vezes a API omite product_url e envia apenas product_handle
        const pUrl = review.product_url || (review.product_handle ? `/products/${review.product_handle}` : null);
        const pTitle = review.product_title || review.product_handle || 'Ver Produto';
        
        // Atualiza a review com os dados consolidados para os IFs de renderização lá embaixo
        review.product_url = pUrl;
        review.product_title = pTitle;

        if (review.pictures_urls && review.pictures_urls.length > 0) {
          const img = review.pictures_urls[0].url || review.pictures_urls[0];
          return { ...review, displayImage: img, source: 'customer' };
        }
        
        if (pUrl) {
          try {
            const response = await fetch(`${pUrl}.js`);
            const product = await response.json();
            if (product && product.featured_image) {
              const resImg = product.featured_image.replace(/(\.[^.]+)$/, '_200x$1');
              return { ...review, displayImage: resImg, source: 'product' };
            }
          } catch (e) {}
        }
        return { ...review, displayImage: null, source: 'none' };
      };

      const enrichedReviews = await Promise.all(reviewsData.slice(0, 15).map(fetchProductImage));

      container.innerHTML = '';

      enrichedReviews.forEach((review) => {
        if (!review.product_url) return;

        const slide = document.createElement('div');
        slide.className = 'swiper-slide';

        let imageHTML = '';
        if (review.displayImage) {
          if (review.product_url) {
            imageHTML = `
              <a href="${review.product_url}" class="judgeme-reviews__image-wrapper">
                <img src="${review.displayImage}" class="judgeme-reviews__image" loading="lazy" alt="Review by ${review.reviewer_name || 'Cliente'}">
              </a>
            `;
          } else {
            imageHTML = `
              <div class="judgeme-reviews__image-wrapper">
                <img src="${review.displayImage}" class="judgeme-reviews__image" loading="lazy" alt="Review by ${review.reviewer_name || 'Cliente'}">
              </div>
            `;
          }
        }

        const starsHTML = '<span class="jdgm-star jdgm--on"></span>'.repeat(5);
        
        slide.innerHTML = `
          <div class="judgeme-reviews__card ${review.displayImage ? 'has-image' : 'no-image'}">
            ${imageHTML}
            <div class="judgeme-reviews__stars">${starsHTML}</div>
            <p class="judgeme-reviews__body">${review.body_html || review.body || ''}</p>
            <div class="judgeme-reviews__meta">
              <span class="judgeme-reviews__author">${review.reviewer_name || review.author || 'Cliente'}</span>
              ${review.product_url ? `<a href="${review.product_url}" class="judgeme-reviews__product-link">${review.product_title || 'Ver Produto'}</a>` : ''}
            </div>
          </div>
        `;
        container.appendChild(slide);
      });

      // Initialize Swiper
      new Swiper(`#swiper-${sectionId}`, {
        slidesPerView: 1.4,
        centeredSlides: true,
        slidesPerGroup: 1,
        spaceBetween: 15,
        loop: enrichedReviews.length > 1,
        autoplay: {
          delay: 5000,
          disableOnInteraction: false,
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
        breakpoints: {
          768: { 
            slidesPerView: 3,
            centeredSlides: false,
            spaceBetween: 20 
          },
          1024: {
            slidesPerView: 4,
            centeredSlides: false,
            spaceBetween: 25
          },
          1280: {
            slidesPerView: 5,
            centeredSlides: false,
            spaceBetween: 30
          }
        }
      });
    });
  };

  document.addEventListener('DOMContentLoaded', init);
  if (Shopify.designMode) document.addEventListener('shopify:section:load', init);
})();
